export default __webpack_public_path__ + "static/media/DisneyBelle.9f762860.jpg";